<div class="container">
  <div class="row center">
    <div class="col col-50 white" style="text-align: center; padding: 2rem">
      <h2>Iniciar sesión</h2>
      @if (!isAuthenticating && !hasSession) {
        <p>Pulsa el botón para iniciar sesión mediante SSO.</p>
      }
      @if (isAuthenticating) {
        <p>Redirigiendo al proveedor SSO...</p>
      }
      <app-spinner
        [display]="isAuthenticating"
        [class]="'spinner-container'"
        [messageToDisplay]="'Autenticando...'"
      ></app-spinner>
      <button
        type="button"
        (click)="manualLogin()"
        [disabled]="isAuthenticating"
        style="margin-top: 1rem"
      >
        {{ isAuthenticating ? 'Procesando...' : 'Iniciar sesión con Azure AD' }}
      </button>
      @if (errorMessage) {
        <div style="color: #b00020; margin-top: 1rem">{{ errorMessage }}</div>
      }
    </div>
  </div>
</div>

<ng-template #formError let-control="control" let-message="message" let-validation="validation">
  @if (control.hasError(validation) && (control.dirty || control.touched)) {
    <div class="fv-plugins-message-container">
      <span role="alert">
        {{ message }}
      </span>
    </div>
  }
</ng-template>
